import React from "react";
import classnames from "classnames";
import { Item } from "@outplayed/tooltips";

const ItemsList = (props) => {
  const { items, patch, dim, disableTooltip, winConditionClass, isProfileOwner } = props;

  const list = items.map((itemId, index) => {
    const validItem = itemId !== 0;
    return (
      <div
        key={index}
        className={classnames("item-wrapper", { "no-item": validItem }, winConditionClass)}
        style={{ width: `${dim}px`, height: `${dim}px` }}
      >
        {validItem && (
          <Item className="sprite" itemId={itemId} spriteSize={dim} isSprite patch={patch} disableTooltip={disableTooltip} />
        )}
      </div>
    );
  });

  return <div className="items-container">{list}</div>;
};

export default ItemsList;
